<template>
  <base-message-page title="Url non valido" message="Controlla la correttezza del link utizzato" />
</template>

<script>
import BaseMessagePage from '@/components/BaseMessagePage.vue'

export default {
  components: {
    BaseMessagePage,
  },
}
</script>
